import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/browser'

import { Auth0ProviderWithNavigate } from 'auth0-provider-with-navigate'
import { App } from './App'

Sentry.init({
  dsn: process.env.SENTRY_UI_URL,
  release: process.env.GIT_HASH,
  environment: process.env.RELEASE_ENV,
})

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <BrowserRouter>
    <Auth0ProviderWithNavigate>
      <App />
    </Auth0ProviderWithNavigate>
  </BrowserRouter>
)
